import React, { useState } from 'react';
import { useParams } from 'react-router';
import properties from '../properties';
import PropertyDetailNav from './PropertyDetailNav';
import CurrencyButtons from './CurrencyButtons';

import './PropertyDetail.css';
import { Link } from 'react-router-dom';

const PropertyDetail = () => {
  const params = useParams();
  const [currencySymbol, setCurrencySymbol] = useState('NGN');
  const [propertyData, setPropertyData] = useState(properties);

  const handleCurrencySymbol = (data) => {
    setCurrencySymbol(data);
  };

  const handleCurrencyRates = (currencyRates, refKey) => {
    const conversionRates = {
      naira: 1, // Assume NGN is the base currency
      dollar: 1 / currencyRates.NGN,
      pound: (1 / currencyRates.NGN) * currencyRates.GBP,
      euro: (1 / currencyRates.NGN) * currencyRates.EUR,
    };
    const selectedRate = conversionRates[refKey] || 1;
    const updatedPropertyData = properties.map((property, index) => ({
      ...property,
      id: index + 1,
      price: parseFloat(property.price * selectedRate).toFixed(2),
    }));
    setPropertyData(updatedPropertyData);
  };

  const filteredProperty = propertyData.find(
    (property,index) => index + 1 === Number(params.id)
  );

  const formatPrice = (value, currency) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
      value
    );

  return (
    <div>
      <PropertyDetailNav />
      <CurrencyButtons
        currencySymbolHandler={handleCurrencySymbol}
        currencyRatesHandler={handleCurrencyRates}
      />
      {filteredProperty && (
        <div className="property_details">
          <div className='property_images'>
            <img src={`${filteredProperty.mainImage}`} alt="A fine apartment" className='main_image'/>
          <div className="other_images">
            {filteredProperty.otherImages.map((image, index) => (
              <img key={index} src={image} alt={`Property ${index + 1}`} />
            ))}
          </div>
          </div>

          <div className="p_detail_right">
            <h2 className="name_property">{filteredProperty.name}</h2>
            {filteredProperty.description.map((para, i) => (
              <p key={i} className="description_property">
                {para}
              </p>
            ))}
            <p className="price_property">
              <span>Price:</span>

              {filteredProperty.price === 0 ? (
                <span>SOLD OUT</span>
              ) : (
                <span>
                  {formatPrice(filteredProperty.price, currencySymbol)}
                </span>
              )}
            </p>
            <p className="type_property">
              <span>Property Type:</span>
              <span>{filteredProperty.type}</span>
            </p>
            <p className="location_property">
              <span>Location:</span>
              <span>{filteredProperty.location}</span>
            </p>
            {filteredProperty.mortgageAvailable === 'True' ? (
              <div className="p-mortgage mortgage_property">
                <p>Mortgage</p>
                <p>Available</p>
              </div>
            ) : (
              ''
            )}
            <Link
              className="detail_cta_btn"
              to="/contacts"
              target="_blank"
              rel="noopener noreferrer"
            >
              Enquiry
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyDetail;
